

























import { Vue } from "vue-property-decorator";

// codemirror
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/theme/monokai.css'

// compnents
import DmoHeader from './components/header.vue'
import Gradientbackground from './components/gradient-background.vue'
import VueCodemirrorPreview from './components/vue-codemirror-preview.vue'

import { State, Getter, Action, Mutation } from 'vuex-class'
import Component from 'vue-class-component'
import { detect, LANG } from 'program-language-detector'
import { themes } from 'vue-codemirror-component'
import { isGithubResourceURL } from './util/github-raw'
import { Transformer } from './store/index'

@Component({
  components: { DmoHeader, Gradientbackground, VueCodemirrorPreview }
})
export default class App extends Vue {

  @Mutation('SELECT_MODE') SELECT_MODE
  @Mutation('SET_INPUT') SET_INPUT
  @Mutation('SET_INPUT_LANG') SET_INPUT_LANG
  @Mutation('SET_OUTPUT_LANG') SET_OUTPUT_LANG

  @Action('GET_GITHUB_FILE_INPUT') GET_GITHUB_FILE_INPUT

  // transform
  @Getter('value') value
  @Getter('inputLang') inputLang
  @Getter('inputLang') outputLang
  @Getter('activeTransformer') activeTransformer

  @Getter('modes') modes
  @Getter('detectLanguage') detectLanguage

  // user
  @Getter('userUrl') userUrl
  @Getter('username') username

  isFocus = false

  inputFocus() {
    this.isFocus = true
  }

  inputBlur() {
    this.isFocus = false
  }

  created() {
    this.SELECT_MODE(this.modes[0].key)
  }

  handleInput() {
    const { input, isUrl } = isGithubResourceURL(this.value)
    if (isUrl) {
      this.GET_GITHUB_FILE_INPUT(input)
    } else {
      this.SET_INPUT(input)
    }
  }

  get result() {
    let result
    if (this.detectLanguage) {
      let inputDetectResult = detect(this.value)
      if (inputDetectResult !== this.inputLang && inputDetectResult !== LANG.Unknown) {
        this.SET_INPUT_LANG(inputDetectResult)
      }
    }
    try {
      result = this.activeTransformer(this.value)
    }
    catch (error) {
      result = error.message
    }
    if (this.detectLanguage) {
      let outputDetectResult = detect(result)
      if (outputDetectResult !== this.outputLang) {
        this.SET_OUTPUT_LANG(outputDetectResult)
      }
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue